import React, { FC, JSX } from 'react';
import styles from './Banner.module.scss';
import { IconName } from '@/components/atoms/Icon/iconMap';
import clsx from 'clsx';
import { Icon } from '@/components/atoms/Icon';
import { Typographies, Typography } from '@/components/atoms/Typography';
import { IconButton, IconButtonVariants } from '@/components/atoms/IconButton';

type BannerType = 'default' | 'success' | 'error';

const iconNames: Record<BannerType, { name: IconName; color: string }> = {
  default: {
    name: 'general/information-circle/24',
    color: 'var(--icon-primary)',
  },
  success: {
    name: 'general/checkmark-circle/24',
    color: 'var(--icon-green)',
  },
  error: {
    name: 'general/alert-circle/24',
    color: 'var(--icon-red)',
  },
};

type BannerProps = {
  id?: string;
  type?: BannerType;
  title?: string | JSX.Element;
  text?: string | JSX.Element;
  isWithIcon?: boolean;
  onClose?: () => void;
};

const Banner: FC<BannerProps> = ({ isWithIcon = true, type = 'default', title, text, onClose }) => {
  return (
    <div className={clsx(styles.banner, styles[type])}>
      {isWithIcon && (
        <Icon name={iconNames[type].name} size={24} color={iconNames[type].color} className={styles.icon} />
      )}

      <div className={styles.info}>
        {title && (
          <Typography variant={Typographies.LABEL_1_SEMIBOLD} className={styles.info__title}>
            {title}
          </Typography>
        )}
        {text && <Typography variant={Typographies.BODY_1_REGULAR}>{text}</Typography>}
      </div>

      {onClose && (
        <IconButton
          variant={IconButtonVariants.SIMPLE}
          size="small"
          className={styles.close_button}
          Icon={() => <Icon name="navigation/close/16" size={16} color="var(--icon-secondary)" />}
          onClick={onClose}
        />
      )}
    </div>
  );
};

export { Banner, type BannerProps };
